import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { boolean } from 'yup';

interface IReceiptDashSlice {
  showColumnSettings:boolean;
  selection:any
}

const initialState: IReceiptDashSlice = {
  showColumnSettings:false,
  selection:{}
};

export const getInGetOutDashboardSlice = createSlice({
  name: 'themeSettings',
  initialState,
  reducers: {
    toggleColumnSettingsPayDash:(state,action)=>{
        state.showColumnSettings = action.payload
    },
    updateSelectedRow:(state,action)=>{
      state.selection = action.payload
  }
  },
});

export const { toggleColumnSettingsPayDash,updateSelectedRow} = getInGetOutDashboardSlice.actions;

export default getInGetOutDashboardSlice.reducer;
